// removed by extract-text-webpack-plugin
module.exports = {"meta":"styles-module__meta___3nYGd","nav":"styles-module__nav___2QAee","active":"styles-module__active___NTv8P","elsewhere":"styles-module__elsewhere___2-5SF","icon":"styles-module__icon____npvt","twtr":"styles-module__twtr___3l9HT styles-module__icon____npvt","linkedin":"styles-module__linkedin___3gB4J styles-module__icon____npvt","soundcloud":"styles-module__soundcloud___22k0h styles-module__icon____npvt","github":"styles-module__github___1Vgi9 styles-module__icon____npvt"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/components/Sidebar/styles.module.css
// module id = 188
// module chunks = 0